export default __webpack_public_path__ + "static/media/return.b7caafce.svg";